import { motion } from "framer-motion";

export function LikertRow({ q, scale, value, onChange, index }) {
  const options = [1, 2, 3, 4, 5];
  return (
    <motion.div
      initial={{ opacity: 0, y: 10 }}
      animate={{ opacity: 1, y: 0 }}
      transition={{ duration: 0.25, delay: Math.min(index * 0.02, 0.3) }}
      className="rounded-xl border border-[#E2E8F0] bg-white p-5 sm:p-6"
      data-testid={`question-${q.n}`}
    >
      <div className="flex items-start gap-3">
        <span className="mt-0.5 font-display text-lg text-[#2563EB]">{q.n}.</span>
        <p className="text-base leading-relaxed text-[#1E293B]">{q.text}</p>
      </div>
      <div className="mt-4 flex flex-wrap gap-2 sm:gap-3">
        {options.map((opt) => {
          const active = value === opt;
          return (
            <button
              key={opt}
              type="button"
              onClick={() => onChange(q.n, opt)}
              data-testid={`q${q.n}-option-${opt}`}
              className={`flex flex-1 min-w-[64px] flex-col items-center rounded-lg border px-2 py-2.5 transition-transform duration-200 ease-out hover:-translate-y-1 focus:outline-none focus:ring-2 focus:ring-[#2563EB] ${
                active
                  ? "border-[#2563EB] bg-[#2563EB] text-white"
                  : "border-[#E2E8F0] bg-white text-[#1E293B]/70 hover:border-[#2563EB]/50"
              }`}
            >
              <span className="text-base font-semibold">{opt}</span>
              <span className={`mt-0.5 text-[10px] leading-tight ${active ? "text-white/90" : "text-[#1E293B]/45"}`}>
                {scale[String(opt)]}
              </span>
            </button>
          );
        })}
      </div>
    </motion.div>
  );
}
